<template>
  <div class="discover">
    <div class="nav-container">
      <div class="search-container">
        <input @focus="handle2Search" placeholder="请输入名称搜索" type="text" />
        <van-icon name="search" />
      </div>
      <ul class="nav">
        <li @click="$router.push('/alumn')">
          <i class="iconfont iconzhuanji"></i>
          专辑
        </li>
        <li
          @click="handleSelectNav(item)"
          :class="{actActive: actActive === item.id}"
          v-for="item in actList"
          :key="item.id"
        >
          {{ item.value }}
        </li>
      </ul>
      <!-- <nav></nav> -->
      <find-nav></find-nav>
      <div class="nav-bar-container">
        <div @click="orderTypeShow = true">
          {{ orderTypeTxt }}
          <img style="width:12px" src="./../../assets/image/find/content_icon_dropdown2x.png" alt="" />
        </div>
        <div @click="screenTypeShow = true">
          <div :class="{active: index != -1}">
            筛选
            <img
              v-if="index == -1"
              style="width:12px"
              src="./../../assets/image/find/content_icon_funnel2x.png"
              alt=""
            />
            <img v-else style="width:12px" src="@/assets/image/find/content_icon_treeselect3x.png" alt="" />
          </div>
        </div>
      </div>
    </div>

    <div>
      <van-list
        :immediate-check="false"
        class="main-content"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <box v-for="item in list" :key="item.id" :online="item" />
      </van-list>
    </div>

    <van-action-sheet v-model="orderTypeShow" :actions="orderList" @select="onSelectOorderType" />
    <van-action-sheet v-model="screenTypeShow" :actions="screenList" @select="onSelectScreenType" />
  </div>
</template>

<script>
import {getFindInfo} from '@/api'
export default {
  components: {
    box: () => import('./box'),
    findNav: () => import('./nav')
  },
  data() {
    return {
      loading: false,
      finished: false,
      actActive: 0,
      actList: [
        {
          id: 0,
          value: '全部'
        },
        {
          id: 1,
          value: '录播'
        },
        {
          id: 2,
          value: '同步课'
        },
        {
          id: 5,
          value: '教研'
        },
        {
          id: 6,
          value: '直播'
        },
        {
          id: 3,
          value: '视频会议'
        },
        {
          id: 7,
          value: '纯直播'
        }
      ],
      // =======
      orderTypeTxt: '最新',
      orderTypeShow: false,
      screenTypeShow: false,
      screenList: [
        {name: '全部', value: 1, color: '#4465F3'},
        {name: '学科筛选', value: 2, color: '#323233'},
        {name: '标签筛选', value: 3, color: '#323233'}
      ],
      orderList: [
        {name: '最新', value: 1, color: '#4465F3'},
        {name: '最热', value: 2, color: '#323233'},
        {name: '最赞', value: 3, color: '#323233'}
      ],
      list: [],
      search: '',
      totalDatas: 0,
      pageNo: 1,
      pageSize: 20,
      totalPageSize: 0,
      orderType: 1,
      resourceFamily: 0, // 分类（0:全部,1：录播预约，2：同步课堂，3：视频会议，4：直播教研，5：互动教研，6：直播，7;活动化直播）
      stageId: -1, // 阶段ID（基础信息接口获取）
      gradeId: -1, // 年级ID（基础信息接口获取）
      subjectId: -1, // 科目ID（基础信息接口获取）
      versionId: -1, // 版本ID（基础信息接口获取）
      catalogId: -1, // 目录id（基础信息接口获取）
      lableId: -1, // 标签ID （标签信息接口获取）
      queryType: 1, // 筛选方式(1科目,2标签,默认值：1)
      // =====label=============
      index: -1, // 赛选
      labelIdActive: -1,
      navActive: -1
    }
  },
  created() {
    const {index, navActive, active, stageId, gradeId, subjectId, versionId, categoryId} = this.$route.query
    if (index === '2') {
      this.index = index
      this.labelIdActive = active
      this.navActive = navActive

      this.screenList.forEach(item => {
        item.color = '#323233'
      })
      this.screenList[index].color = '#4465F3'
      this.queryType = 2
      this.lableId = active
    } else if (index === '1') {
      this.index = index
      this.stageId = stageId
      this.gradeId = gradeId
      this.subjectId = subjectId
      this.versionId = versionId
      this.catalogId = categoryId
      this.screenList.forEach(item => {
        item.color = '#323233'
      })
      this.screenList[index].color = '#4465F3'
      this.queryType = 1
    }
    this.init()
  },
  methods: {
    async onLoad() {
      if (this.pageNo >= this.totalPageSize) {
        this.finished = true
        return
      }
      this.pageNo = this.pageNo + 1
      this.loading = true
      this.init()
    },
    init() {
      const data = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        orderType: this.orderType,
        resourceFamily: this.resourceFamily,
        stageId: this.stageId,
        gradeId: this.gradeId,
        subjectId: this.subjectId,
        versionId: this.versionId,
        catalogId: this.catalogId,
        lableId: this.lableId,
        queryType: this.queryType
      }
      getFindInfo(data).then(res => {
        this.list = [...this.list, ...res.data]
        this.totalDatas = res.totalDatas * 1
        this.totalPageSize = Math.ceil(this.totalDatas / this.pageSize)
        this.finished = false
        this.loading = false
      })
    },
    handleSelectNav(item) {
      this.actActive = item.id
      this.resourceFamily = item.id
      // this.finished = false
      this.pageNo = 1
      this.list = []
      this.init()
    },
    onSelectOorderType(info) {
      this.orderList.forEach(item => {
        item.color = '#323233'
      })
      info.color = '#4465F3'
      this.orderTypeTxt = info.name
      this.orderType = info.value
      this.orderTypeShow = false
      this.finished = false
      this.pageNo = 1
      this.list = []
      this.init()
    },
    onSelectScreenType(info) {
      if (info.value === 1) {
        this.screenList.forEach(item => {
          item.color = '#323233'
        })
        info.color = '#4465F3'
        this.screenTypeShow = false
        this.pageNo = 1
        this.resourceFamily = 0

        this.stageId = -1
        this.gradeId = -1
        this.subjectId = -1
        this.versionId = -1
        this.catalogId = -1
        this.lableId = -1
        this.queryType = -1
        this.index = -1
        this.list = []
        this.init()
      }
      if (info.value === 2) {
        this.$router.push('/subjects')
      }
      if (info.value === 3) {
        if (this.index === '2') {
          this.$router.push({
            path: '/labels',
            query: {
              index: this.navActive,
              active: this.labelIdActive
            }
          })
        } else {
          this.$router.push('/labels')
        }
      }
    },
    handle2Search() {
      this.$router.push('/search')
    }
  }
}
</script>

<style lang="scss" scoped>
.discover {
  .nav-container {
    background-image: linear-gradient(rgba(255, 255, 255, 1), rgba(244, 246, 249, 1));
    padding: 0 16px;
  }
}
.search-container {
  position: relative;
  padding: 12px 0;
  input {
    background: #f4f6f9;
    border: none;
    outline: none;
    width: 100%;
    padding: 10px 40px 10px 20px;
    border-radius: 18px;
  }
  input::-webkit-input-placeholder {
    color: #c0c4cc;
    font-size: 14px;
  }
  i {
    position: absolute;
    right: 10px;
    top: 50%;
    font-size: 20px;
    transform: translateY(-50%);
  }
}
ul.nav {
  white-space: nowrap;
  overflow-x: scroll;
  // padding: 0 16px;

  &::-webkit-scrollbar {
    display: none;
  }
  li {
    display: inline-block;
    background: #f4f6f9;
    border: 1px solid #e5e8ec;
    border-radius: 14px;
    padding: 4px 10px;
    font-weight: 500;
    color: #303133;
    font-size: 13px;
  }
  li + li {
    margin-left: 10px;
  }
  li.actActive {
    color: rgb(68, 101, 243);
    background: rgba(68, 101, 243, 0.1);
  }
}
.nav-bar-container {
  position: relative;
  // padding: 0 16px;
  margin-top: 2px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  color: #303133;
  font-weight: 500;
}

.main-content {
  margin-top: 20px;
  padding: 0 16px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  background: #f4f6f9;
}
.active {
  color: #4465f3;
}
</style>
<style lang="scss">
.main-content {
  .van-list__loading,
  .van-list__finished-text {
    width: 100%;
  }
}
</style>
